import React from 'react';

function phaseLabel(daysBefore) {
	if (daysBefore > 30) return 'Early prep';
	if (daysBefore > 7) return 'Getting ready';
	if (daysBefore > 0) return 'Final week';
	if (daysBefore === 0) return 'Arrival';
	return 'On trail';
}

function JourneyTimelinePanel({ timeline, onGoToStep, activeStepId }) {
	if (!timeline || timeline.length === 0) return null;
	return (
		<div className="guided-panel guided-panel--timeline">
			<h3 className="guided-panel__title">Preparation timeline</h3>
			<p className="guided-panel__intro">Countdown from today — what to do and when before you fly.</p>
			<ol className="guided-timeline">
				{timeline.map((item) => {
					const isLinkedStep = item.stepId && item.stepId === activeStepId;
					return (
						<li
							key={`${item.daysBefore}-${item.label}`}
							className={`guided-timeline__item guided-timeline__item--${item.daysBefore > 0 ? 'before' : item.daysBefore === 0 ? 'arrival' : 'trail'}${isLinkedStep ? ' is-current' : ''}`}
						>
							<div className="guided-timeline__marker" aria-hidden="true" />
							<div className="guided-timeline__card">
								<div className="guided-timeline__when">
									<span className="guided-timeline__phase">{phaseLabel(item.daysBefore)}</span>
									<span className="guided-timeline__date">
										{item.daysBefore > 0 && `${item.daysBefore} days before`}
										{item.daysBefore === 0 && 'Arrival day'}
										{item.daysBefore < 0 && 'On trail'}
									</span>
								</div>
								<strong className="guided-timeline__label">{item.label}</strong>
								<p>{item.task}</p>
								{item.stepId && onGoToStep && (
									<button
										type="button"
										className={`guided-timeline__link${isLinkedStep ? ' is-current' : ''}`}
										onClick={() => onGoToStep(item.stepId)}
									>
										{isLinkedStep ? 'Current step' : `Open ${item.label} step →`}
									</button>
								)}
							</div>
						</li>
					);
				})}
			</ol>
		</div>
	);
}

export default JourneyTimelinePanel;
